import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  class: "col-6",
  style: {"max-width":"calc(50vw - 22px)"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", null, "Свойства панелей", -1)
const _hoisted_4 = {
  class: "col-6",
  style: {"max-width":"calc(50vw - 22px)"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Длины", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanPanelPropertyJournal = _resolveComponent("PlanPanelPropertyJournal")!
  const _component_PlanPanelLengthJournal = _resolveComponent("PlanPanelLengthJournal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_PlanPanelPropertyJournal, {
        parentModel: _ctx.parentModel,
        parentEditingConfig: _ctx.parentEditingConfig,
        onUpdateParent: _ctx.updateParent
      }, null, 8, ["parentModel", "parentEditingConfig", "onUpdateParent"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_PlanPanelLengthJournal, {
        parentModel: _ctx.parentModel,
        parentEditingConfig: _ctx.parentEditingConfig,
        onUpdateParent: _ctx.updateParent
      }, null, 8, ["parentModel", "parentEditingConfig", "onUpdateParent"])
    ])
  ]))
}